import React, { Component } from 'react';
import Alert from 'react-s-alert'

class CustomErrorAlert extends Component {

  render() {

    return (
      <div className='popup verify components-CustomAlert'>
        <div className='popup_inner verify' style={{padding: "30px 20px", height: "auto", width: "50%"}}>
          <button className='close' onClick={Alert.closeAll}></button>
          
          <h1 style={{color: "#c90000"}}>{this.props.error.message}</h1>
        </div>
      </div>
    );
  }
}

export default CustomErrorAlert


// WEBPACK FOOTER //
// ./src/components/CustomErrorAlert.js